module.exports = __webpack_public_path__ + "img/phoneCalling-icon.68fcafcb.svg";